import { render } from "./VabeneParrainagePage.vue?vue&type=template&id=3797ddec&scoped=true&ts=true"
import script from "./VabeneParrainagePage.vue?vue&type=script&lang=ts"
export * from "./VabeneParrainagePage.vue?vue&type=script&lang=ts"

import "./VabeneParrainagePage.vue?vue&type=style&index=0&id=3797ddec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3797ddec"]])

export default __exports__